import {TeacherClassroomsTable} from './TeacherClassroomsTable';

export default TeacherClassroomsTable;
